import * as React from 'react';
import {Helmet} from 'react-helmet';

import {Body} from 'shells/typography/body';
import {useResizeObserver} from 'shells/utils/hooks/use-resize-observer';

import {AUTH_LINK_VARIANTS} from '../signup/consts';
import {MainHeader} from '../signup/main-header';

// @ts-expect-error
import loginData from './login';
import {MULTI_ACCOUNT_LOGIN_MODES, type MultiAccountLoginMode} from './types';
import {WhatsNew} from './whats-new';

import styles from './new-login-layout.module.css';

type ReadMore = {
    fullText: string;
    linkText: string;
    url: string;
};

export type LoginData = {
    title: string;
    featureSectionTitle: string;
    readMore: ReadMore;
};

type Props = {
    form: React.ReactNode;
    loginMode: MultiAccountLoginMode | null;
};

export function NewLoginLayout(props: Props) {
    const [headerRef, setHeaderRef] = React.useState<any>(null);
    const data: LoginData = loginData;

    // done to allow us to align the header and whats new content
    // left edges with one another while still remaining centered
    // overall in the column
    const [headerWidth] = useResizeObserver(headerRef);
    const isSwitching = props.loginMode === MULTI_ACCOUNT_LOGIN_MODES.SWITCHING;

    return (
        <div className={styles['grid-container']}>
            <Helmet>
                <meta name='viewport' content='width=device-width,initial-scale=1' />
            </Helmet>
            <div className={styles.grid}>
                <div className={styles['main-header']}>
                    <MainHeader
                        authLinkVariant={props.loginMode ? undefined : AUTH_LINK_VARIANTS.SIGN_UP}
                    />
                </div>
                <div className={styles.header}>
                    <div ref={(ref) => setHeaderRef(ref)} className='width-fit-content'>
                        {isSwitching ? 'Let’s get you back in' : data.title}
                    </div>
                </div>
                <div className={styles['whats-new']}>
                    <div
                        className={isSwitching ? 'text-align-center' : undefined}
                        style={{width: headerWidth}}
                    >
                        {isSwitching ? (
                            <Body size='xlarge'>Your session for this account has expired.</Body>
                        ) : (
                            <WhatsNew />
                        )}
                    </div>
                </div>
                <div className={styles.form}>{props.form}</div>
            </div>
        </div>
    );
}
